import { useSelector } from "react-redux";

/**
 * Returns ID of the selected Client.
 */
export const useClientId = () => {
    // @ts-ignore
    return useSelector((state) => state.clients?.selection?.idClient);
};
